export default __webpack_public_path__ + "/dist/images/2225223.png";